import { render } from "./IconCompress.vue?vue&type=template&id=45c91948"
import script from "./IconCompress.vue?vue&type=script&lang=ts"
export * from "./IconCompress.vue?vue&type=script&lang=ts"
script.render = render

export default script